import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, usePage, useStore, useToast } from "@/comn/hooks";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { APIS, SF_COMN_CD_MGMT_MSTR_INFO, SG_COMN_CD_MGMT_DTL_LIST, URLS } from "./services/OsciComnCdAppService";
import { OSCI0109005Q } from "./OSCI0109005Q";

/*
 * Common Code Details
 * !== 공통 코드 상세 ==!
 */
export const OSCI0109003Q = (props: any) => {
    const { pgeUid } = usePage({
        auth: ["auth_osci0003"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal();
    const toast = useToast();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const { comnCd } = useParams();
    const [params] = useSearchParams();
    const bsopClsfCd = params.get("bsopClsfCd");

    const form = {
        comnCdMgmtMstrInfo: useForm({
            defaultSchema: SF_COMN_CD_MGMT_MSTR_INFO,
        }),
    };

    const fetch = {
        // Check common code information !== 공통 코드 정보 조회 ==!
        getComnCdMstrInfo: useFetch({
            api: () => APIS.getComnCdMstrInfo(comnCd),
            enabled: !!comnCd,
            onSuccess: (data) => {
                const comnCdMgmtMstrInfo = data.comnCdMstr.content;
                form.comnCdMgmtMstrInfo.setValues(comnCdMgmtMstrInfo);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
            showToast: true,
        }),
        // Delete Common Code !== 공통 코드 삭제 ==!
        deleteComnCdMstr: useFetch({
            api: (comnCd) => APIS.deleteComnCdMstr(comnCd),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00006", // Processed successfully. !== 성공적으로 처리 되었습니다. ==!
                    onCancel: () => {
                        navigate(URLS.osci0109001q);
                    },
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00040" }), // Failed to remove. !== 삭제가 실패하였습니다. ==!
            showToast: true,
        }),
    };

    const handler = {
        // Delete Common Code !== 공통 코드 삭제 ==!
        deleteComnCdMstr: () => {
            modal.openModal({
                content: "msg.osc.00062", // Confirm remove? !== 삭제하시겠습니까? ==!
                onConfirm: () => {
                    fetch.deleteComnCdMstr.fetch(comnCd);
                },
            });
        },
    };

    useEffect(() => {
        form.comnCdMgmtMstrInfo.setEditable(false);
        fetch.getComnCdMstrInfo.fetch();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtMstrInfo.schema.comnCd} />
                            <Group.Control {...form.comnCdMgmtMstrInfo.schema.bsopClsfCd} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtMstrInfo.schema.comnCdNmEn} />
                            <Group.Control {...form.comnCdMgmtMstrInfo.schema.comnCdNmTz} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtMstrInfo.schema.comnCdNmKo} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtMstrInfo.schema.comnCdDataLenVal} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtMstrInfo.schema.useYn} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtMstrInfo.schema.frstRegstId} />
                            <Group.Control {...form.comnCdMgmtMstrInfo.schema.frstRgsrDtm} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            {/* Common Code valid Value List Grid !== 공통 코드 유효 값 목록 그리드 ==! */}
            <OSCI0109005Q />
            <Layout>
                <Layout.Left>
                    <Layout.Button
                        role={"list"}
                        onClick={() => {
                            if (bsopClsfCd) {
                                navigate(`${URLS.osci0109001q}?bsopClsfCd=${bsopClsfCd}`);
                            } else {
                                navigate(URLS.osci0109001q);
                            }
                        }}
                    />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button
                        role={"edit"}
                        onClick={() => {
                            if (bsopClsfCd) {
                                navigate(`${URLS.osci0109004s}/${comnCd}?bsopClsfCd=${bsopClsfCd}`);
                            } else {
                                navigate(`${URLS.osci0109004s}/${comnCd}`);
                            }
                        }}
                    />
                    <Layout.Button
                        role={"delete"}
                        onClick={() => {
                            handler.deleteComnCdMstr();
                        }}
                    />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
